const vi = {
    accepted: ':attribute phải được chấp nhận.',
    alpha: 'Trường :attribute phải là ký tự',
    alpha_dash: ':attribute chỉ chấp nhận ký tự chữ cái, số, dấu gạch chéo và gạch dưới.',
    alpha_num: ':attribute phải là ký tự chữ cái hoặc chữ số.',
    attributes: {},
    between: ':attribute phải nằm trong khoảng :min và :max.',
    confirmed: ':attribute xác nhận không trùng khớp.',
    email: ':attribute không phải là email.',
    date: ':attribute không phải là ngày hợp lệ',
    def: 'Thuộc tính :attribute có lỗi.',
    digits: ':attribute phải là số và có chiều dài bằng :digits.',
    digits_between: 'Độ dài của trường :attribute phải nằm trong khoảng :min and :max chữ số.',
    different: 'Giá trị của hai trường :attribute và :different phải khác nhau.',
    in: 'Giá trị được chọn của :attribute không hợp lệ.',
    integer: ':attribute phải là số nguyên.',
    hex: 'The :attribute should have hexadecimal format',
    min: {
        numeric: ':attribute phải lớn hơn hoặc bằng :min.',
        string: ':attribute phải có ít nhất :min ký tự.',
    },
    max: {
        numeric: ':attribute phải nhỏ hơn hoặc bằng :max.',
        string: ':attribute phải có ít hơn :max ký tự.',
    },
    not_in: 'Giá trị được chọn của trường :attribute không hợp lệ.',
    numeric: ':attribute phải là số.',
    present: 'Trường :attribute phải có mặt (nhưng có thể để trống).',
    required: ':attribute bắt buộc nhập.',
    required_if: ':attribute là bắt buộc khi :other có giá trị :value.',
    same: 'Giá trị của :attribute và :same phải như nhau.',
    size: {
        numeric: ':attribute phải có chiều dài của bằng :size.',
        string: 'Số ký tự của :attribute phải là :size ký tự.',
    },
    string: ':attribute không phải là một chuỗi',
    url: ':attribute không phải là một Url hợp lệ.',
    regex: ':attribute không đúng định dạng',
};
export default vi;
